/* Carry a suit's native variant and supported fit choices through the Fit Guide.
   No measurements, consent, customer information or cart state are stored. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.GiorgioFitContext = api;
    api.start(root.document, root.location);
  }
})(typeof window === 'undefined' ? this : window, function () {
  const fits = new Set(['Modern', 'Slim']);
  const lengths = new Set(['Short', 'Regular', 'Long']);
  function productReturn(value, origin, themeId) {
    try {
      if (!value || !value.startsWith('/') || value.startsWith('//')) return null;
      const source = new URL(value, origin);
      if (source.origin !== origin || !/^\/products\/[a-z0-9][a-z0-9-]*\/?$/.test(source.pathname)) return null;
      const url = new URL(source.pathname, origin);
      const variant = source.searchParams.get('variant');
      if (variant && /^\d+$/.test(variant)) {
        url.searchParams.set('variant', variant);
        const waist = source.searchParams.get('g_pant_waist');
        if (/^[1-9]\d$/.test(waist || '')) url.searchParams.set('g_pant_waist', waist);
      }
      const view = source.searchParams.get('view');
      if (['giorgio', 'giorgio-preorder'].includes(view)) url.searchParams.set('view', view);
      if (/^\d+$/.test(String(themeId || ''))) url.searchParams.set('preview_theme_id', String(themeId));
      return url;
    } catch (_) { return null; }
  }
  function property(product, name) {
    const fields = [...product.querySelectorAll('input,select')].filter(field => field.name === `properties[${name}]` && !field.disabled);
    return fields.find(field => field.type === 'radio' || field.type === 'checkbox' ? field.checked : Boolean(field.value))?.value || '';
  }
  function fitDestination(anchor, product, location, themeId) {
    try {
      const guide = new URL(anchor.href, location.origin);
      if (guide.origin !== location.origin || !/^\/pages\/fit-guide\/?$/.test(guide.pathname)) return null;
      const current = productReturn(location.pathname + location.search, location.origin, themeId);
      if (!current) return null;
      const variant = product.querySelector('[data-variant-id]')?.value;
      if (variant && /^\d+$/.test(variant)) current.searchParams.set('variant', variant);
      guide.searchParams.set('return_to', current.pathname + current.search);
      const fit = property(product, 'Fit'), length = property(product, 'Jacket Length');
      guide.searchParams.delete('return_fit');
      guide.searchParams.delete('return_length');
      if (fits.has(fit)) guide.searchParams.set('return_fit', fit);
      if (lengths.has(length)) guide.searchParams.set('return_length', length);
      if (/^\d+$/.test(String(themeId || ''))) guide.searchParams.set('preview_theme_id', String(themeId));
      return guide;
    } catch (_) { return null; }
  }
  function start(document, location) {
    const themeId = document.body?.dataset.gThemeId;
    const guide = document.querySelector('[data-g-fit-guide]');
    if (guide) {
      const params = new URL(location.href).searchParams;
      const back = productReturn(params.get('return_to'), location.origin, themeId);
      const link = guide.querySelector('[data-g-fit-return]');
      if (back && link) {
        const fit = params.get('return_fit'), length = params.get('return_length');
        if (fits.has(fit)) back.searchParams.set('g_fit', fit);
        if (lengths.has(length)) back.searchParams.set('g_length', length);
        link.href = back.href;
        link.hidden = false;
      }
    }
    const product = document.querySelector('giorgio-product');
    if (!product) return;
    // Capture newly created drawer links too, without changing their native actions.
    const prepare = event => {
      const anchor = event.target.closest?.('a[href]');
      if (!anchor || !product.contains(anchor)) return;
      const destination = fitDestination(anchor, product, location, themeId);
      if (destination) anchor.href = destination.href;
    };
    product.addEventListener('click', prepare, true);
    product.addEventListener('auxclick', prepare, true);
    product.addEventListener('contextmenu', prepare, true);
    const params = new URL(location.href).searchParams;
    const wanted = [['Fit', params.get('g_fit'), fits], ['Jacket Length', params.get('g_length'), lengths]]
      .filter(([, value, allowed]) => allowed.has(value));
    if (!wanted.length) return;
    const untouched = new Set(wanted.map(([name]) => name));
    product.addEventListener('change', event => {
      if (!event.isTrusted) return;
      for (const [name] of wanted) if (event.target.name === `properties[${name}]`) untouched.delete(name);
    }, true);
    function restore() {
      for (const [name, value] of wanted) {
        if (!untouched.has(name)) continue;
        const fields = [...product.querySelectorAll('input,select')].filter(field => field.name === `properties[${name}]` && !field.disabled);
        const field = fields.find(item => item.tagName === 'SELECT' ? [...item.options].some(option => option.value === value && !option.disabled) : item.value === value && item.type === 'radio');
        if (!field) continue;
        untouched.delete(name);
        if (field.tagName === 'SELECT') field.value = value;
        else field.checked = true;
        field.dispatchEvent(new Event('change', {bubbles: true}));
      }
      if (!untouched.size) observer.disconnect();
    }
    const observer = new MutationObserver(restore);
    observer.observe(product, {childList: true, subtree: true});
    restore();
    // Late/failed app loading must never keep an observer alive indefinitely.
    document.defaultView.setTimeout(() => observer.disconnect(), 15000);
  }
  return {productReturn, fitDestination, start};
});
